document.addEventListener("DOMContentLoaded", function () {
  const wishlistKey = "shopify_wishlist";

  function formatMoney(cents, currency = '₹') {
    const amount = (cents / 100).toFixed(2);
    return `${currency}${amount}`;
  }

  function resizeImg(url, width) {
    if (!url) return url;
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}width=${width}`;
  }

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(wishlistKey) || "[]");
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    try {
      localStorage.setItem(wishlistKey, JSON.stringify(list));
    } catch (e) {
      console.warn("Wishlist could not be saved:", e);
    }
  }

  function isInWishlist(handle) {
    return getWishlist().includes(handle);
  }

  function addToWishlist(handle) {
    const list = getWishlist();
    if (!list.includes(handle)) {
      list.push(handle);
      saveWishlist(list);
      updateWishlistCount();
    }
  }

  function removeFromWishlist(handle) {
    let list = getWishlist();
    list = list.filter(h => h !== handle);
    saveWishlist(list);
    updateWishlistCount();

    const pageItem = document.querySelector(`.wishlist-item[data-handle="${handle}"]`);
    if (pageItem) {
      pageItem.remove();
    }

    const remaining = getWishlist();
    if (document.querySelector("#wishlist-items") && remaining.length === 0) {
      document.querySelector("#wishlist-items").innerHTML = '<p class="wishlist-empty-state">Your wishlist is empty.</p>';
    }
  }

  function updateWishlistCount() {
    const count = getWishlist().length;
    const bubble = document.querySelector("#wishlist-count-bubble");
    const countSpan = document.querySelector("#wishlist-count");

    if (bubble && countSpan) {
      if (count > 0) {
        countSpan.textContent = count;
        bubble.style.display = "";
      } else {
        bubble.style.display = "none";
      }
    }
  }

  document.body.addEventListener("click", function (e) {
    const btn = e.target.closest(".wishlist-btn");
    if (!btn) return;

    const handle = btn.dataset.productHandle;
    if (!handle) return;

    if (isInWishlist(handle)) {
      removeFromWishlist(handle);
      btn.classList.remove("is-wishlisted");
      btn.setAttribute("aria-pressed", "false");
    } else {
      addToWishlist(handle);
      btn.classList.add("is-wishlisted");
      btn.setAttribute("aria-pressed", "true");
    }
  });

  function updateWishlistIcons() {
    document.querySelectorAll(".wishlist-btn").forEach(btn => {
      const handle = btn.dataset.productHandle;
      if (!handle) return;

      if (isInWishlist(handle)) {
        btn.classList.add("is-wishlisted");
        btn.setAttribute("aria-pressed", "true");
      } else {
        btn.classList.remove("is-wishlisted");
        btn.setAttribute("aria-pressed", "false");
      }
    });
  }

  function initSliderDrag(cardEl) {
    const slider = cardEl.querySelector("[data-slider]");
    const track = cardEl.querySelector("[data-track]");
    const dotsWrap = cardEl.querySelector("[data-dots]");
    const dots = dotsWrap ? Array.from(dotsWrap.querySelectorAll(".wishlist-item-dot")) : [];
    const slides = track ? Array.from(track.children) : [];
    const total = slides.length;

    if (!slider || !track || total <= 1) return;

    let current = 0;

    function goTo(index) {
      if (index < 0) index = total - 1;
      if (index >= total) index = 0;
      current = index;
      track.style.transform = `translateX(-${current * 100}%)`;
      dots.forEach((d, i) => d.classList.toggle("is-active", i === current));
    }

    dots.forEach((dot, i) => {
      dot.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        goTo(i);
      });
    });

    let touchStartX = 0, touchDeltaX = 0, isTouching = false;
    slider.addEventListener("touchstart", function (e) {
      touchStartX = e.touches[0].clientX;
      touchDeltaX = 0;
      isTouching = true;
    }, { passive: true });
    slider.addEventListener("touchmove", function (e) {
      if (!isTouching) return;
      touchDeltaX = e.touches[0].clientX - touchStartX;
    }, { passive: true });
    slider.addEventListener("touchend", function () {
      if (!isTouching) return;
      isTouching = false;
      if (Math.abs(touchDeltaX) > 40) {
        goTo(touchDeltaX < 0 ? current + 1 : current - 1);
      }
      touchDeltaX = 0;
    });

    let mouseStartX = 0, mouseDeltaX = 0, isMouseDragging = false;

    slider.addEventListener("mousedown", function (e) {
      mouseStartX = e.clientX;
      mouseDeltaX = 0;
      isMouseDragging = true;
      slider._wasDragging = false;
      slider.classList.add("is-dragging");
    });

    window.addEventListener("mousemove", function (e) {
      if (!isMouseDragging) return;
      mouseDeltaX = e.clientX - mouseStartX;
      if (Math.abs(mouseDeltaX) > 5) {
        slider._wasDragging = true;
      }
    });

    window.addEventListener("mouseup", function (e) {
      if (!isMouseDragging) return;
      isMouseDragging = false;
      slider.classList.remove("is-dragging");
      if (Math.abs(mouseDeltaX) > 40) {
        e.preventDefault();
        goTo(mouseDeltaX < 0 ? current + 1 : current - 1);
      }
      mouseDeltaX = 0;
    });

    slider.addEventListener("dragstart", function (e) {
      e.preventDefault();
    });

    slider.addEventListener("click", function (e) {
      if (slider._wasDragging) {
        e.preventDefault();
        e.stopPropagation();
        slider._wasDragging = false;
      }
    }, true);

    goTo(0);
  }

  function renderWishlist() {
    const container = document.querySelector("#wishlist-items");
    if (!container) return;

    const handles = getWishlist();

    if (handles.length === 0) {
      container.innerHTML = '<p class="wishlist-empty-state">Your wishlist is empty.</p>';
      return;
    }

    Promise.allSettled(
      handles.map(handle =>
        fetch(`/products/${handle}.js`).then(r => {
          if (!r.ok) throw new Error(`404: ${handle}`);
          return r.json();
        })
      )
    ).then(results => {
      const products = [];
      const deadHandles = [];

      results.forEach((res, i) => {
        if (res.status === "fulfilled") {
          products.push(res.value);
        } else {
          deadHandles.push(handles[i]); // product deleted/unpublished/renamed
        }
      });

      // auto-remove dead handles so they don't keep failing forever
      if (deadHandles.length > 0) {
        const cleaned = getWishlist().filter(h => !deadHandles.includes(h));
        saveWishlist(cleaned);
        updateWishlistCount();
      }

      container.innerHTML = "";

      if (products.length === 0) {
        container.innerHTML = '<p class="wishlist-empty-state">Your wishlist is empty.</p>';
        return;
      }

      products.forEach(product => {
        const images = product.images && product.images.length > 0 ? product.images : [product.featured_image];

        const dotsHtml = images
          .map((img, i) => `<span class="wishlist-item-dot${i === 0 ? ' is-active' : ''}"></span>`)
          .join("");

        const imagesHtml = images
          .map((img, i) => `<a href="${product.url}" class="wishlist-item-image-link"><img src="${resizeImg(img, 600)}" alt="${product.title}" draggable="false" loading="lazy" decoding="async" width="600" height="600"></a>`)
          .join("");

        const div = document.createElement("div");
        div.className = "wishlist-item";
        div.dataset.handle = product.handle;
        div.innerHTML = `
          <div class="wishlist-item-slider" data-slider>
            <div class="wishlist-item-track" data-track>
              ${imagesHtml}
            </div>
            ${images.length > 1 ? `<div class="wishlist-item-dots" data-dots>${dotsHtml}</div>` : ""}
          </div>
          <div class="wishlist-item-info">
            <a href="${product.url}" class="wishlist-item-title">${product.title}</a>
            <span class="wishlist-item-price">
              ${product.compare_at_price && product.compare_at_price > product.price ? `<span class="wishlist-item-compare-price">${formatMoney(product.compare_at_price)}</span>` : ""}
              ${formatMoney(product.price)}
            </span>
            <button class="wishlist-item-remove" data-handle="${product.handle}">Remove</button>
          </div>
        `;
        container.appendChild(div);

        initSliderDrag(div);
      });

      container.querySelectorAll(".wishlist-item-remove").forEach(btn => {
        btn.addEventListener("click", () => {
          removeFromWishlist(btn.dataset.handle);
        });
      });
    });
  }

  if (document.querySelector("#wishlist-items")) {
    renderWishlist();
  }

  updateWishlistCount();
  updateWishlistIcons();
});